import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CardState } from './card.state';

// selectors
export const selectCardModule = createFeatureSelector<CardState>('card');

// ---------------------------------------------------------------------------------------------------------------------

export const selectAddCardShown = createSelector(selectCardModule,
    (state: CardState) => state.addCard.shown);

export const selectSearchText = createSelector(selectCardModule,
    (state: CardState) => state.addCard.searchText);

export const selectAddCardList = createSelector(selectCardModule,
    (state: CardState) => state.addCard.addCardList);

export const selectAddCardParams = createSelector(selectCardModule,
    (state: CardState) => state.addCard.addCardParams);

export const selectSuggestedCardList = createSelector(selectCardModule,
    (state: CardState) => state.addCard.suggestedCardList);

export const selectAddCardExpandedCardList = createSelector(selectCardModule,
    (state: CardState) => state.addCard.expandedCardList);

export const selectAddCardExpandedCardDetails = createSelector(selectCardModule,
    (state: CardState) => state.addCard.expandedCardDetails);

// ---------------------------------------------------------------------------------------------------------------------


export const selectEnabledCardList = createSelector(selectCardModule,
    (state: CardState) => state.enabledCardList);

export const selectEnabledCardParams = createSelector(selectCardModule,
    (state: CardState) => state.enabledCardParams);

export const selectExpandedCardList = createSelector(selectCardModule,
    (state: CardState) => state.expandedCardList);

export const selectCardDetails = createSelector(selectCardModule,
    (state: CardState) => state.cardDetails);

export const selectBackupCardDetails = createSelector(selectCardModule,
    (state: CardState) => state.backupCardDetails);

// ---------------------------------------------------------------------------------------------------------------------

export const selectCardAdd = createSelector(selectCardModule,
    (state: CardState) => state.cardAddAuth);

export const selectCardAddAuthorization = createSelector(selectCardModule,
    (state: CardState) => state.cardAddAuth ? state.cardAddAuth.authorization : null);

// ---------------------------------------------------------------------------------------------------------------------

export const selectLoadingStatus = createSelector(selectCardModule,
    (state: CardState) => state ? state.loadingStatus : null);

export const selectLoadingError = createSelector(selectCardModule,
    (state: CardState) => state ? state.loadingError : null);

// ---------------------------------------------------------------------------------------------------------------------

export const selectUpdatePermissions = createSelector(selectCardModule,
    (state: CardState) => state.updatePermissions);

export const selectUpdatePermissionsAuthorization = createSelector(selectCardModule,
    (state: CardState) => state.updatePermissions ? state.updatePermissions.authorization : null);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/card/card.selector.ts